import { useReducer } from 'react'

import GCMContext from '../../../components/gcm/GCMContext'
import GCMState from '../../../components/gcm/GCMState'
import GcmModal from './GcmModal'
import GcmModalOld from './GCMModalOld'

const GCMContainer = ({
	onSuccess = () => {},
	onAuthSuccess = () => {},
	oldFlow = false,
}) => {
	return (
		<GCMContext.Provider value={useReducer(GCMState, {})}>
			{oldFlow ? (
				<GcmModalOld onSuccess={onSuccess} onAuthSuccess={onAuthSuccess} />
			) : (
				<GcmModal onSuccess={onSuccess} onAuthSuccess={onAuthSuccess} />
			)}
		</GCMContext.Provider>
	)
}

export default GCMContainer
